/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Tab_ActivityInputs */

const cs_clients_tab_activity = /** @type {(inputs: Clients_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivita`)
};

const en_clients_tab_activity = /** @type {(inputs: Clients_Tab_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity`)
};

/**
* | output |
* | --- |
* | "Activity" |
*
* @param {Clients_Tab_ActivityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_tab_activity = /** @type {((inputs?: Clients_Tab_ActivityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Tab_ActivityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_tab_activity(inputs)
	return cs_clients_tab_activity(inputs)
});